import { TRIGGER_FETCH_BANK_LIST_API_SUCCESS } from 'redux/actionTypes';

const initialState = [];

// export const locale[];

const BankListReducer = (state = initialState, action) => {
	switch (action.type) {
		case TRIGGER_FETCH_BANK_LIST_API_SUCCESS:
			return {
				...state,
				...action.data,
			};
		default:
			return state;
	}
};

export default BankListReducer;
